const oneighty = [
  {
    name: '2g-sim',
    type: '180',
    size: '180px'
  },
  {
    name: '3g-sim',
    type: '180',
    size: '180px'
  },
  {
    name: '4g-sim',
    type: '180',
    size: '180px'
  },
  {
    name: 'account-manager',
    type: '180',
    size: '180px'
  },
  {
    name: 'calls',
    type: '180',
    size: '180px'
  },
  {
    name: 'connections',
    type: '180',
    size: '180px'
  },
  {
    name: 'dashboard',
    type: '180',
    size: '180px'
  },
  {
    name: 'data-connectivity',
    type: '180',
    size: '180px'
  },
  {
    name: 'discount-tickets',
    type: '180',
    size: '180px'
  },
  {
    name: 'dnd-activate',
    type: '180',
    size: '180px'
  },
  {
    name: 'dnd-desactivate',
    type: '180',
    size: '180px'
  },
  {
    name: 'ensuring-uninterrupted-services-business',
    type: '180',
    size: '180px'
  },
  {
    name: 'find-rates',
    type: '180',
    size: '180px'
  },
  {
    name: 'get-help',
    type: '180',
    size: '180px'
  },
  {
    name: 'international-roaming',
    type: '180',
    size: '180px'
  },
  {
    name: 'internet',
    type: '180',
    size: '180px'
  },
  {
    name: 'iplc',
    type: '180',
    size: '180px'
  },
  {
    name: 'isd',
    type: '180',
    size: '180px'
  },
  {
    name: 'isd-advanced',
    type: '180',
    size: '180px'
  },
  {
    name: 'itfs',
    type: '180',
    size: '180px'
  },
  {
    name: 'maintenance',
    type: '180',
    size: '180px'
  },
  {
    name: 'messages',
    type: '180',
    size: '180px'
  },
  {
    name: 'network-issues',
    type: '180',
    size: '180px'
  },
  {
    name: 'one-more-product',
    type: '180',
    size: '180px'
  },
  {
    name: 'organization',
    type: '180',
    size: '180px'
  },
  {
    name: 'pay-outstanding-invoices',
    type: '180',
    size: '180px'
  },
  {
    name: 'payment-allocated',
    type: '180',
    size: '180px'
  },
  {
    name: 'payment-trends',
    type: '180',
    size: '180px'
  },
  {
    name: 'payment-uncompleted',
    type: '180',
    size: '180px'
  },
  {
    name: 'search-files',
    type: '180',
    size: '180px'
  },
  {
    name: 'thought-leadership-article-on-ddos',
    type: '180',
    size: '180px'
  },
  {
    name: 'upload-tds',
    type: '180',
    size: '180px'
  },
  {
    name: 'whats-next',
    type: '180',
    size: '180px'
  }
];

export default oneighty;



// WEBPACK FOOTER //
// ./src/containers/foundations/Illustrations/constants/oneighty.js